import { z } from "zod";

export const taskSchema = z.object({
  title: z.string().min(1, "Task title is required").min(3, "Must be at least 3 characters"),
  description: z.string().optional(),
  priority: z.enum(["low", "medium", "high"]),
  dueDate: z.string().optional(),
});
